import React from 'react'
import "./Services.css"
import { Title } from "../../../../components"
import { Container } from 'react-bootstrap'
import plane from "../../../../assets/images/home/services-plane.svg"

const Services = ({ pageData, url }) => {

    const servicesData = pageData?.templates?.find(template => template.section === "Packages Promotion")?.data;

  return (
    <div className="services-container">
      <img
        src={
          servicesData?.packages_promotion_bg
            ? url + servicesData.packages_promotion_bg
            : require("../../../../assets/images/home/bg2.png")
        }
        alt=""
        className="services-img"
      />
      <img
        src={
          servicesData?.packages_promotion_bg_down
            ? url + servicesData.packages_promotion_bg_down
            : require("../../../../assets/images/home/bg3.png")
        }
        alt=""
        className="services-img-down"
      />
      <Container className="margin-top">
        <div data-aos="fade-down" data-aos-duration="1300">
          <Title
            title={servicesData?.packages_promotion_title1}
            desc={servicesData?.packages_promotion_subtitle1}
            para={servicesData?.packages_promotion_desc1}
          />
        </div>

        <div className="services-content">
          <div data-aos="fade-right" data-aos-duration="1300">
            <Title
              title={servicesData?.packages_promotion_title2}
              desc={servicesData?.packages_promotion_subtitle2}
              para={servicesData?.packages_promotion_desc2}
            />
          </div>

          <img
            src={
              servicesData?.packages_promotion_icon
                ? url + servicesData.packages_promotion_icon
                : plane
            }
            className="services-plane"
          />
          <div data-aos="fade-left" data-aos-duration="1300">
            <Title
              title={servicesData?.packages_promotion_title3}
              desc={servicesData?.packages_promotion_subtitle3}
              para={servicesData?.packages_promotion_desc3}
            />
          </div>

          <img
            src={
              servicesData?.packages_promotion_icon
                ? url + servicesData.packages_promotion_icon
                : plane
            }
            className="services-plane responsive-img"
          />
        </div>
        <div className="services-image-container">
          <div
            className="services-image"
            data-aos="fade"
            data-aos-duration="1300"
          >
            <img
              src={
                servicesData?.packages_promotion_image
                  ? url + servicesData.packages_promotion_image
                  : require("../../../../assets/images/home/services.png")
              }
            />
          </div>
        </div>
        <div
          className="services-package"
          data-aos="fade-down"
          data-aos-duration="1300"
        >
          <Title
            title={servicesData?.packages_promotion_title4}
            desc={servicesData?.packages_promotion_subtitle4}
          />
          {/* <a
            className="services-package-btn"
            href={`${
              servicesData.packages_promotion_link
                ? servicesData.packages_promotion_link
                : "#"
            }`}
          >
            {servicesData.packages_promotion_button}
          </a> */}
          <a
            className="services-package-btn"
            onClick={(e) => {
              e.preventDefault();
              const hasCookies = document.cookie && document.cookie.length > 0;

              if (hasCookies) {
                window.open("/mypackages", "_blank");
              } else {
                window.open("/login", "_blank");
              }
            }}
          >
            {servicesData?.packages_promotion_button}
          </a>
        </div>
      </Container>
    </div>
  );
}

export default Services